import * as React from "react";
import {Button, Divider, Grid, Modal} from "semantic-ui-react";
import {DiffWrapper} from "../configEdit/diff/DiffWrapper";


interface ScriptCompareModalProps {
    isOpen: boolean;
    onClose: () => void;
    scriptA: string;
    titleA?: string;
    scriptB: string;
    titleB?: string;
}

export function ScriptCompareModal(props: React.PropsWithChildren<ScriptCompareModalProps>) {
    const {isOpen, onClose, scriptA, scriptB} = props;

    if (!isOpen) {
        return null;
    }

    return <Modal
        open={isOpen}
        onClose={onClose}
        dimmer="inverted"
        size='fullscreen'
    >
        <Modal.Header>Script Comparison</Modal.Header>
        <Modal.Content>

            {scriptA === scriptB && <p style={{color: "green"}}>Scripts are identical</p>}
            {scriptA !== scriptB && <Grid>
                <Grid.Row>
                    <Grid.Column width={8} textAlign={"center"}>
                        <h3>{props.titleA || "Script A"}</h3>
                    </Grid.Column>
                    <Grid.Column width={8} textAlign={"center"}>
                        <h3>{props.titleB || "Script B"}</h3>
                    </Grid.Column>
                </Grid.Row>
            </Grid>}
            <Divider/>

            <DiffWrapper
                oldText={scriptA.toString()}
                newText={scriptB.toString()}
            />
            <Button
                style={{marginTop: "10px"}}
                onClick={onClose}
                color='blue'
                content='Close'
            />
        </Modal.Content>
    </Modal>
}